import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline, Grid } from "@mui/material";
import theme from "./theme.js";
import WeekendView from "./components/gamescreencomps/WeekendView.js";

// The maintenance homepage is intentionally independent of the API,
// WebSocket connections, authentication, and the managed database.
function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="App">
        <header className="App-header">
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Grid item>
              <img
                src={`${process.env.PUBLIC_URL}/assets/WDS_Logo.webp`}
                alt="The Weakday Show"
                style={{
                  width: "clamp(145px, 32vw, 220px)",
                  height: "auto",
                  padding: "5px 10px 0",
                  display: "block",
                }}
              />
            </Grid>
          </Grid>
        </header>
        <main>
          <WeekendView />
        </main>
      </div>
    </ThemeProvider>
  );
}

export default App;
